import { AiOutlineDashboard, AiOutlineFileAdd, AiOutlineWallet, AiOutlineBug, AiFillBank, AiFillTool } from "react-icons/ai";
import { ReactNode } from "react";
import { RoutePermittedRole } from "../shared/constants/AppConst";
import { HiOutlineClipboardList, HiUser } from "react-icons/hi";

export interface RouterConfigData {
  id: string;
  title: string;
  messageId: string;
  icon?: string | ReactNode;
  type: "item" | "group" | "collapse" | "divider";
  children?: RouterConfigData[];
  permittedRole?: RoutePermittedRole;
  color?: string;
  url?: string;
  exact?: boolean;
  count?: number;
}

const routesConfig: RouterConfigData[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    messageId: "sidebar.app.dashboard",
    type: "item",
    icon: <AiOutlineDashboard color="blue" />,
    url: "/dashboard",
  },
  {
    id: "orderlist",
    title: "TransactionHistory",
    messageId: "sidebar.app.transactionHistroy",
    type: "item",
    icon: <HiOutlineClipboardList color="green" />,
    url: "/transaction-history",
  },
  {
    id: "clientManagement",
    title: "ClientManagement",
    messageId: "sidebar.app.clientManagement",
    type: "item",
    icon: <HiUser />,
    url: "/client-management",
  },
  {
    id: "error_logs",
    title: "Error Logs",
    messageId: "sidebar.app.errorLogs",
    type: "item",
    icon: <AiOutlineBug color="red" />,
    url: "/error-logs",
  },
  {
    id: "config_charges",
    title: "Configure Charges",
    messageId: "sidebar.app.configureCharges",
    type: "item",
    icon: <AiFillTool color="#0A8FDC" />,
    url: "/config-charges",
  },
  {
    id: "gateways",
    title: "Payment Gateways",
    messageId: "sidebar.app.paymentGateways",
    type: "item",
    icon: <AiFillBank color="#0A8FDC" />,
    url: "/payment-gateways",
  },
  {
     id: "config_user_charges",
    title: "Configure Charges",
    messageId: "sidebar.app.configureCharges",
    type: "item",
    icon: <AiFillTool color="#0A8FDC" />,
    url: "/config-user-charges",
  },
  {
    id: "subscriptionplan",
    title: "Subscription Plan",
    messageId: "sidebar.app.subscriptionPlan",
    type: "collapse",
    icon: <AiOutlineWallet />,
    children: [
      {
        id: "planlist",
        title: "PlanList",
        messageId: "sidebar.app.planList",
        type: "item",
        icon: <HiOutlineClipboardList />,
        url: "/plan-list",
      },
      {
        id: "addplan",
        title: "AddPlan",
        messageId: "sidebar.app.addPlan",
        type: "item",
        icon: <AiOutlineFileAdd />,
        url: "/add-plan",
      },
    ],
  },
];
export default routesConfig;
